export const CUSTOM_PAGE_TEMPLATE_NODE_TYPE = 'PAGE';
